/**
 * Hero banner image with accessible, SEO-friendly markup.
 */
export default function ToolBanner({ banner, priority = true, className = '' }) {
  if (!banner) return null;

  return (
    <figure className={`w-full ${className}`}>
      <img
        src={banner.src}
        alt={banner.alt}
        title={banner.title}
        width={banner.width}
        height={banner.height}
        loading={priority ? 'eager' : 'lazy'}
        fetchPriority={priority ? 'high' : 'auto'}
        decoding="async"
        className="w-full h-auto rounded-2xl border border-gray-200 shadow-lg object-cover"
      />
      {banner.caption && (
        <figcaption className="mt-3 text-sm text-gray-500 text-center leading-relaxed">
          {banner.caption}
        </figcaption>
      )}
    </figure>
  );
}
